import { Link } from 'react-router';
import { Icon } from '../components/Icon';
import { Seo } from '../components/Seo';

export function NotFoundPage() {
  return (
    <>
      <Seo title="Page not found" description="The requested page could not be found." noIndex />
      <section className="not-found section--grain">
        <div className="shell not-found__inner">
          <span>404</span>
          <h1>That signal path ends here.</h1>
          <p>The page may have moved, or the address may be incomplete.</p>
          <Link className="button button--dark button--large" to="/">Return home <Icon name="arrow" /></Link>
        </div>
      </section>
    </>
  );
}
